import TopNavbar from "@/shared/components/TopNavbar/TopNavbar"
import Sidebar from "@/shared/components/Sidebar/Sidebar"
import { SidebarInset, SidebarProvider } from "@/ui/sidebar"
import styles from "./Layout.module.scss"

interface LayoutProps {
  children: React.ReactNode;
  breadcrumbs: string[];
}

const Layout = ({ children, breadcrumbs }: LayoutProps) => {
  return (
    <SidebarProvider>
      <div className={styles.layout}>
        <header className={styles.header}>
          <TopNavbar breadcrumbs={breadcrumbs} />
        </header>

        <div className={styles.body}>
          <Sidebar />
          <SidebarInset className={styles.content}>
            {children}
          </SidebarInset>
        </div>
      </div>
    </SidebarProvider>
  )
}

export default Layout